import axios from 'axios';
import { useEffect, useState } from 'react';
import PdfDownloadCard from './PdfDownloadCard';

export default function ImportantPdfs({ packId }) {
  const [isPurchased, setIsPurchased] = useState(null);
  const [importantPdfs, setImportantPdfs] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const purchaseResponse = await axios.get(`/api/packs/${packId}/is-purchased`);
        const isPurchasedData = purchaseResponse?.data?.data?.isPurchased;
        if (!isPurchasedData) return;
        setIsPurchased(isPurchasedData);
        if (!isPurchasedData) return;
        const res = await axios.get(`/api/packs/${packId}/download-card-data`);
        const data = res?.data?.data?.links;
        if (data) {
          setImportantPdfs(data);
        }
      } catch (error) {}
    }

    fetchData();
  }, [packId]);

  useEffect(() => {
    if (isPurchased === false) {
      navigate('/v2/home');
    }
  }, [isPurchased]);

  if (!importantPdfs) return null;

  return (
    <div className="grid grid-cols-2 gap-5">
      {importantPdfs?.map((item) => (
        <PdfDownloadCard title={item.title} link={item.url} resourceType={'Miscellaneous Pdf'} />
      ))}
    </div>
  );
}
